export default __webpack_public_path__ + "static/media/gif2.aac362ff.gif";